module.exports = __webpack_public_path__ + "static/img/2.34e77ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/eng/2.png
// module id = wWZT
// module chunks = 0